import { Vue, Component } from 'vue-property-decorator';

@Component({ 
    name: 'PageMixin'
})
export default class PageLisUIMixin extends Vue {
    protected page: any = {
        records: [],                                        // 页面数据
        // layout: 'total, sizes, prev, pager, next, jumper',  // 分页布局
        layout: 'total, prev, pager, next, sizes', 
        pageNo: 1,                                          // 当前页
        pageSize: 50,                                       // 每页显示条数
        total: 0,                                           // 总条数
        pages: 0,                                           // 总页数
        loadding: true,                                     // 请求lodding
    };

    protected pageRest() {
        this.page = {
            records: [],                                        // 页面数据
            // layout: 'total, sizes, prev, pager, next, jumper',  // 分页布局
            layout: 'total, prev, pager, next, sizes', 
            pageNo: 1,                                          // 当前页
            pageSize: 50,                                       // 每页显示条数
            total: 0,                                           // 总条数
            pages: 0,                                           // 总页数
            loadding: true,                                     // 请求lodding
        };
    }

    // 请求参数
    protected searchParam: any = {
        pageNo: 1,
        pageSize: 50,
        conds: {}
    };
 
    // 分页请求
    protected pageRequest(requestApi: any) {
        this.page.pageNo = 1;
        this.searchParam.pageNo = 1;
        this.page.requestApi = requestApi;
        this.page.requestApi();
    }

    // 刷新分页
    protected pageReload(data: any) {
        this.page.total = data.total;
        this.page.records = data.records;
        this.page.loadding = false;

        return true;
    }

    // 选择前往第几页
    protected pageNoChange(pageNo: number) {
        // this.showld()
        this.page.pageNo = pageNo;
        this.searchParam.pageNo = pageNo;
        if (this.page.requestApi !== null && this.page.requestApi !== undefined) {
            this.page.requestApi();
        }
    }

    // 选择每页显示条数
    protected pageSizeChange(pageSize: number) {
        // this.showld()
        this.page.pageSize = pageSize;
        this.searchParam.pageSize = pageSize;
        if (this.page.requestApi !== null && this.page.requestApi !== undefined) {
            this.page.requestApi();
        }
    }
    
    // 计算分页情况下的序号
    protected pageIndex(index: number) {
        index = (index + 1) + (this.page.pageNo - 1) * this.page.pageSize
        return index
    }
    
}
